import { render, staticRenderFns } from "./YearInfoItem.vue?vue&type=template&id=17278a44&"
import script from "./YearInfoItem.vue?vue&type=script&lang=js&"
export * from "./YearInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports